import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { ListBaseComponent } from '../../../components/list-base/list-base.component';
import { AddCustomerComponent } from '../add-customer/add-customer.component';
import { Customer } from '../../../types/types';
import { BreadcrumbService } from 'xng-breadcrumb';
import { NgbModal, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '../../../app.service';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { ColumnMode, DatatableComponent, NgxDatatableModule } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-list-contractor',
  templateUrl: './list-customer.component.html',
  styleUrls: ['./list-customer.component.scss']
})
export class ListCustomerComponent extends ListBaseComponent<Customer> implements OnInit {

  @ViewChild('tableWrapper') tableWrapper;
  @ViewChild('DatatableComponent') ngxDatatable: DatatableComponent;

  private currentComponentWidth
  
  contractorRegistrationObserver: Subscription;

  private _message = new Subject<string>();
  
  alertError : boolean = false;

  message : string = '';

  bShowFilters = false

  contractorName:string = '';
  mobileNumber:string = '';
  mobileNumber2:string = '';
  bankAccountNumber:string = '';
  ifscCode:string = '';
  upiId:string = '';
  verifiedCustomer:string = 'all';
  // 'false' = All Customers, 'true' = All Dealer Employees (set from route data)
  dealerEmployeeFilter:string = 'false';
  
  constructor(protected http: HttpClient, protected breadcrumbService: BreadcrumbService, protected appService: AppService,
    protected offcanvasService: NgbOffcanvas, protected router: Router, protected route:ActivatedRoute, private modalService: NgbModal) {
      super(http,breadcrumbService,appService,offcanvasService,router,route, ); 
     }

  ngOnInit(): void {

    this._message.subscribe((message) => (this.message = message));
    this._message.pipe(debounceTime(5000)).subscribe(() => {
			this.alertError = false;
		});

    // The same component serves "All Customers" (dealerEmployee=false) and
    // "All Dealer Employees" (dealerEmployee=true). Reload when the route changes.
    this.route.data.subscribe((data) => {
      this.dealerEmployeeFilter = data['dealerEmployee'] || 'false';
      this.pageCallback({ offset: 0 });
    });
  }

  ngAfterViewChecked() {
    // Check if the table size has changed,
    if (this.ngxDatatable && this.ngxDatatable.recalculate && (this.tableWrapper.nativeElement.clientWidth !== this.currentComponentWidth)) {
      this.ngxDatatable.columnMode = ColumnMode.standard;
      this.currentComponentWidth = this.tableWrapper.nativeElement.clientWidth;
      this.ngxDatatable.recalculate();
      
    }
  }

  showFilters(){
    this.bShowFilters = !this.bShowFilters
    if( !this.bShowFilters){
      this.clearFilter();
    }
    setTimeout(() => {
      this.ngxDatatable.recalculate()
    }, 100);
  }
  clearFilter(){
    
    this.mobileNumber = ""
    this.mobileNumber2 = ""
    this.bankAccountNumber = ""
    this.ifscCode = ""
    this.upiId = ""
    this.contractorName = ""
    this.verifiedCustomer = "all"
    super.clearFilter();
  }

  applyFilterAfterDelay(){
    setTimeout(() => {
      this.applyFilter();
    }, 10); 
  }

  populateParamsForQuery(params: HttpParams): HttpParams{

    if( this.contractorName.length > 0){
      params = params.set('contractorName', `${this.contractorName}`);
    }
    if( this.mobileNumber.length > 0){
      params = params.set('mobileNumber', `${this.mobileNumber}`);
    }
    if( this.mobileNumber2.length > 0){
      params = params.set('mobileNumber2', `${this.mobileNumber2}`);
    }
    if( this.bankAccountNumber.length > 0){
      params = params.set('bankAccountNumber', `${this.bankAccountNumber}`);
    }
    if( this.ifscCode.length > 0){
      params = params.set('ifscCode', `${this.ifscCode}`);
    }
    if( this.upiId.length > 0){
      params = params.set('upiId', `${this.upiId}`);
    }
    if( this.verifiedCustomer.length > 0 && this.verifiedCustomer !== "all"){
      params = params.set('verified', `${this.verifiedCustomer}`);
    }
    params = params.set('dealerEmployee', `${this.dealerEmployeeFilter}`);
    return params;
  }

  onActivate(event){
    if(event.type == 'click') {
      console.log(event.row);
      this.editContractor(event.row)
    }
  }

  get isDealerEmployeeScreen(): boolean {
    return this.dealerEmployeeFilter === 'true';
  }

  addNewContractor(){

    const modalRef = this.modalService.open(AddCustomerComponent,{ centered: true,size: 'lg' });
    modalRef.componentInstance.name = this.isDealerEmployeeScreen ? 'Add New Dealer Employee' : 'Add / Edit Contractor';
    // When adding from the Dealer Employees screen, create with the flag on.
    modalRef.componentInstance.dealerEmployee = this.isDealerEmployeeScreen;

    if( this.contractorRegistrationObserver ){
      this.contractorRegistrationObserver.unsubscribe();
    }
  
    /*if( values.destinationAirport != undefined && values.destinationAirport.length != 0){
      modalRef.componentInstance.airport = values.destinationAirport;
    }*/

    this.contractorRegistrationObserver = modalRef.componentInstance.contractorEntry.subscribe((contractor) => {
      this.reloadTable()
    });
    
  }

  editContractor(customer){
    
    const modalRef = this.modalService.open(AddCustomerComponent,{ centered: true,size: 'lg' });
    modalRef.componentInstance.name = 'Add / Edit Customer';
    
    if( this.contractorRegistrationObserver ){
      this.contractorRegistrationObserver.unsubscribe();
    }
  
    modalRef.componentInstance.customer = customer;

    this.contractorRegistrationObserver = modalRef.componentInstance.contractorEntry.subscribe((contractor) => {
      this.reloadTable()
    });
    
  }

  protected get loadingUrl(){
    return `${environment.serverUrl}/customer`;
  }

  protected get exportUrl(){
    return `${environment.serverUrl}/customer/export`;
  }

  protected get exportFileName(){
    return `Contractor Report`;
  }

}
